import { render } from "./CrStepMass2Content.vue?vue&type=template&id=70ec291c&scoped=true"
import script from "./CrStepMass2Content.vue?vue&type=script&lang=js"
export * from "./CrStepMass2Content.vue?vue&type=script&lang=js"

import "./CrStepMass2Content.vue?vue&type=style&index=0&id=70ec291c&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ec291c"]])

export default __exports__